export default __webpack_public_path__ + "static/media/876.76c4de7b.png";